import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/presentations/presentations/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`In the Primer presentation templates, you can control all of the footer information from one source of truth.`}</p>
    <p>{`Footer elements can be updated globally within a presentation from the `}<inlineCode parentName="p">{`Variables`}</inlineCode>{` slide which is located in the layout templates of the presentation format in use. Items that can be controlled are the `}<inlineCode parentName="p">{`Username`}</inlineCode>{`, `}<inlineCode parentName="p">{`Presentation Name`}</inlineCode>{`, and `}<inlineCode parentName="p">{`Presentation Note`}</inlineCode>{`.`}</p>
    <h2>{`Accessing the layout template (Keynote)`}</h2>
    <p>{`To access the layout template you can do one of the following:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Step`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Click on `}<strong parentName="td">{`View > Edit Master Slides`}</strong>{` in the menu bar at the top.`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/56168669-b2ba6480-5f90-11e9-9689-f6827e60a8de.png",
              "alt": "Click View > Edit Master Slides in menu bar"
            }}></img></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Click on `}<strong parentName="td">{`Edit Master Slide`}</strong>{` in the Inspector located on the right-hand side.`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/56168688-bea62680-5f90-11e9-835f-38d36bbe67b7.png",
              "alt": "Edit Master Slide in the Inspector"
            }}></img></td>
        </tr>
      </tbody>
    </table>
    <h2>{`Editing the variables`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Step`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Example`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`1. Select the `}<strong parentName="td">{`Variables`}</strong>{` slide on the `}<strong parentName="td">{`Navigator`}{`*`}</strong>{` located on the left-hand side.`}<br />{`*`}{`If you do not see this menu, click `}<strong parentName="td">{`View > Navigator`}</strong>{`.`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/56168721-d54c7d80-5f90-11e9-88a0-2ef672b83c1b.png",
              "alt": "Select the Variables slide"
            }}></img></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`2. Edit the content with your own information. If you'd like to leave a section blank, just add an empty space.`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/57877127-e5dc5780-77cb-11e9-923e-65c2823d70b8.png",
              "alt": "The Variables slide"
            }}></img></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "center"
          }}>{`Demo: Editing variables`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}><img parentName="td" {...{
              "src": "https://user-images.githubusercontent.com/10384315/57877220-21772180-77cc-11e9-9488-a02f156cfb0b.png",
              "alt": "Editing the variables is easy!"
            }}></img></td>
        </tr>
      </tbody>
    </table>
    <p><img parentName="p" {...{
        "src": "https://user-images.githubusercontent.com/10384315/57877221-21772180-77cc-11e9-92b4-56d7599511dc.png",
        "alt": "Changes show instantly in the slides in your presentation"
      }}></img></p>
    <p>{`Any changes to the variables can be seen instantly in both the layout templates and the presentation slides.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      